// Overlapper dersom tid-intervallene overlapper
const areOverlapping = (a, b) => a.startMs < b.endMs && b.startMs < a.endMs;

// Grupper hendelser som overlapper hverandre
const groupOverlapping = evs => {
    const groups = [];
    for (const ev of evs) {
        let placed = false;

        for (const g of groups) {
            if (g.some(e => areOverlapping(e, ev))) {
                g.push(ev);
                placed = true;
                break;
            }
        }

        if (!placed) groups.push([ev]);
    }

    return groups;
};

// Plasser hendelser side om side innenfor overlappende grupper
export const layoutSideBySide = evs => {
    const groups = groupOverlapping(evs);
    const out = [];

    for (const group of groups) {
        const sorted = [...group].sort(
            (a, b) => a.startMs - b.startMs || a.endMs - b.endMs || a.id - b.id
        );

        const lanesEnd = [];
        const items = [];

        for (const ev of sorted) {
            let laneIndex = -1;

            for (let i = 0; i < lanesEnd.length; i++) {
                if (lanesEnd[i] <= ev.startMs) {
                    laneIndex = i;
                    break;
                }
            }

            if (laneIndex === -1) {
                laneIndex = lanesEnd.length;
                lanesEnd.push(ev.endMs);
            } else {
                lanesEnd[laneIndex] = ev.endMs;
            }

            items.push({ ...ev, laneIndex });
        }

        const laneCount = lanesEnd.length || 1;
        out.push(...items.map(ev => ({ ...ev, laneCount })));
    }

    return out;
};
